/** 轨迹回放
 */
const replayFun = {
  /**
   根据各种条件查询轨迹回放
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param searchData {Object} 查询条件
   */
  getRouteByDevId(_this, url, searchData) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        devId: searchData.devId,
        selectCondition: searchData.condition,
        beginTime: searchData.beginTime,
        endTime: searchData.endTime
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.trackerPointList = []
        _this.cautionPointList = []
        // 车辆设备对应KEY
        // let carKeyList = [5, 23, 24, 25, 26, 27, 28, 29]
        // let shipKeyList = [6, 31]
        if (res.data.data.length > 0 && res.data.data[0].locationList.length > 0 && res.data.data[0].route !== null) {
          _this.play = false
          let routeTotalTime = 0
          _this.watchDeviceList = res.data.data
          for (let item in res.data.data) {
            _this.pointNum = _this.pointNum + res.data.data[item].locationList.length
            _this.trackerPointList = _this.trackerPointList.concat(res.data.data[item].locationList)
            _this.routeTotalMileage = _this.routeTotalMileage + res.data.data[item].route.routeTotalMileage / 1000
            routeTotalTime = routeTotalTime + res.data.data[item].route.routeTotalTime
            if (res.data.data[item].route !== null && res.data.data[item].route !== '') {
              let lng = res.data.data[item].route.routeBeginLon * 1
              let lat = res.data.data[item].route.routeBeginLat * 1
              let endLng = res.data.data[item].route.routeEndLon * 1
              let endLat = res.data.data[item].route.routeEndLat * 1
              _this.watchDeviceList[item].begigCoordinate = lng.toFixed(6) + ',' + lat.toFixed(6)
              _this.watchDeviceList[item].endCoordinate = endLng.toFixed(6) + ',' + endLat.toFixed(6)
              
              // 添加高德坐标的起始点经纬度
              if (res.data.data[item].locationList && res.data.data[item].locationList.length > 0) {
                // 获取起始点的高德坐标
                const startIndex = 0;
                const endIndex = res.data.data[item].locationList.length - 1;
                
                // 添加起始点高德坐标
                res.data.data[item].route.routeBeginLonGcj02 = res.data.data[item].locationList[startIndex].lLonGcj02;
                res.data.data[item].route.routeBeginLatGcj02 = res.data.data[item].locationList[startIndex].lLatGcj02;
                
                // 添加终点高德坐标
                res.data.data[item].route.routeEndLonGcj02 = res.data.data[item].locationList[endIndex].lLonGcj02;
                res.data.data[item].route.routeEndLatGcj02 = res.data.data[item].locationList[endIndex].lLatGcj02;
                
                // 初始化高德地图的地址属性
                _this.watchDeviceList[item].begigCoordinateGcj02 = null;
                _this.watchDeviceList[item].endCoordinateGcj02 = null;
              }
            }
          }

          for (let item in _this.trackerPointList) {
            if (_this.trackerPointList[item].cType !== '' && _this.trackerPointList[item].cType !== null) {
              _this.cautionPointList.push(_this.trackerPointList[item])
            }
            let lng = _this.trackerPointList[item].lLonBd09 * 1
            let lat = _this.trackerPointList[item].lLatBd09 * 1
            _this.trackerPointList[item].coordinate = lng.toFixed(6) + ',' + lat.toFixed(6)
          }
          _this.maxRoute = _this.trackerPointList.length
          _this.caPointList = []
          _this.trPointList = []
          for (let i = 0; i < 10; i++) {
            _this.caPointList.push(_this.cautionPointList[i])
          }
          for (let i = 0; i < 10; i++) {
            _this.trPointList.push(_this.trackerPointList[i])
          }
          console.log(_this.trackerPointList)
          console.log(_this.cautionPointList)
          console.log(_this.caPointList)
          let hour = routeTotalTime / 3600000
          let second = routeTotalTime % 3600000
          let minute = parseInt(second / 60000)
          let ss = second % 60000
          _this.routeTotalTime = parseInt(hour).toString() + '时' + minute.toString() + '分' + ss / 1000 + '秒'
          if (_this.routeTotalMileage === 0) {
            _this.routeSpeed = ''
          } else {
            _this.routeSpeed = (_this.routeTotalMileage / hour).toFixed(2)
          }
          // 根据当前地图类型调用不同的绘制方法
          if (_this.mapType === "amap") {
            _this.drawPolylineAmap(res.data.data)
          } else {
            _this.drawPolyline(res.data.data)
          }
          console.log(_this.$refs.watchDeviceTable)
          if (_this.$refs.watchDeviceTable != undefined) { _this.$refs.watchDeviceTable.toggleAllSelection() }
        } else {
          _this.mapLoading = false
          _this.watchDeviceList = []
          _this.routeTotalMileage = 0
          _this.routeTotalTime = '0时0分0秒'
          _this.routeSpeed = 0
          _this.pointNum = 0
          _this.$message({
            message: '设备此时间范围暂无行程信息！',
            type: 'warning'
          })
        }
      } else {
        _this.mapLoading = false
        _this.watchDeviceList = []
        _this.routeTotalMileage = 0
        _this.routeTotalTime = '0时0分0秒'
        _this.routeSpeed = 0
        _this.pointNum = 0
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
    })
  }
}
export default replayFun



// WEBPACK FOOTER //
// ./src/javascript/function/replayFun.js